var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.obj.description || _vm.obj.branch)?_c('span',[(_vm.prefix)?_c('span',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(" "),(_vm.obj.description)?_c('span',[_vm._v(_vm._s(_vm.obj.description))]):_vm._e(),_vm._v(" "),(!_vm.obj.description)?_c('span',[_vm._v(_vm._s(_vm.obj.branch))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/common/description.vue?vue&type=template&id=22109310
// module id = hhfb
// module chunks = 0